<template>
    <v-display :form="form" :path="path" :label="label" value="" hide-underline original>
        <q-btn-group class="v-radio-button q-mt-xs full-width" push>
            <q-btn v-for="option in options"
                   :key="option.value"
                   :icon="option.icon"
                   :color="inputValue == option.value ? (option.color ? option.color : color) : 'light'"
                   :class="{'text-dark': inputValue != option.value}"
                   :dark="inputValue != option.value"
                   :disable="form.busy || disable"
                   @click="inputValue = option.value; onInput()"
                   no-caps push class="col">
                <span v-html="option.label"></span>
            </q-btn>
        </q-btn-group>
    </v-display>
</template>

<script>
    import mixins from './mixins'
    import {
        QBtnGroup,
        QBtn
    } from 'quasar-framework'

    export default {
        name: 'VRadioButtons',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            }
        },

        components: {
            QBtnGroup,
            QBtn
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VRadioButtons.vue